import { FC, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import packageInfo from '../../../../package.json'
import { useTheme } from '../../context/ThemeContext'

const AuthLayout: FC = () => {
  const { theme } = useTheme()

  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className={`d-flex ${
        theme === 'dark' ? 'dark__div' : ''
      } flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed`}
    >
      <div
        className={`${
          theme === 'dark' ? 'dark__div' : ''
        } d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-8`}
      >
        <div
          className={`${
            theme === 'dark' ? 'layout__  theme__div' : ''
          } w-lg-550px w-sm-550px  rounded shadow-sm  p-lg-15 p-md-10 p-sm-7 p-5 mx-auto`}
          style={{ width: '100%' }}
        >
          <Outlet />
        </div>
      </div>
      <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex align-items-center fw-bold fs-6'>
          <a
            href={`${process.env.REACT_APP_B4IGO_LANDING_PAGE}/#about`}
            className='text-muted text-hover-primary px-2'
          >
            About
          </a>
          <a
            href={`${process.env.REACT_APP_B4IGO_LANDING_PAGE}/#footer-contact`}
            className='text-muted text-hover-primary px-2'
          >
            Contact
          </a>
          <span className='text-muted text-hover-primary px-2'>
            Version: {packageInfo.version}
          </span>
        </div>
      </div>
    </div>
  )
}

export default AuthLayout
